import script from "./ProfileCredentialsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCredentialsPage.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCredentialsPage.vue?vue&type=style&index=0&id=fd8ad0c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd8ad0c8"]])

export default __exports__